export default __webpack_public_path__ + "static/media/void_checkbox.d2258d21.svg";